import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-outline',
  templateUrl: './icon-account-outline.component.html',
  styleUrl: './icon-account-outline.component.scss',
  standalone: false,
})
export class IconAccountOutlineComponent {
  @Input() tooltip?: string;
}
